module.exports = __webpack_public_path__ + "assets/images/premium-locked-screen/shift-tasks/shift-modal-139ec2.svg";